import { config } from "@/config";
import store from '@/store';

/**
 * Formatea una cadena de fecha a formato visual DD/MM/YYYY.
 *
 * Acepta dos formatos de entrada:
 *   - DD/MM/YYYY  — devuelto directamente por algunos endpoints del backend.
 *   - YYYY-MM-DD  — formato ISO estándar, incluyendo variantes ISO 8601
 *                   con parte horaria (YYYY-MM-DDTHH:mm:ss...).
 *
 * Devuelve null si el valor está vacío o no se reconoce el formato.
 *
 * @param {string|null|undefined} fecha
 * @returns {string|null}
 */
export function formatearFecha(fecha) {
    if (!fecha) return null;
    const str = String(fecha).trim();

    // Formato DD/MM/YYYY — devuelto tal cual por algunos endpoints
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
        return str;
    }

    // Formato ISO YYYY-MM-DD (o ISO 8601 con parte horaria)
    const soloFecha = str.slice(0, 10);
    const [year, month, day] = soloFecha.split('-');
    if (!year || !month || !day) return null;
    return `${day}/${month}/${year}`;
}

export function useFilters() {
    const formatearPrecio = value => {
        if (!value || value <= 0) value = 0;
        const moneyFormatter = new Intl.NumberFormat(...config.CURRENCY);
        return moneyFormatter.format(value);
    };

    const formatearMetodoPago = value => {
        const metodos_de_pago_abonos_bases = store.getters.getTeatro?.metodos_pago_abonos_bases_ventas;

        if (metodos_de_pago_abonos_bases && metodos_de_pago_abonos_bases.length > 0) {
            for (let i = 0; i <= metodos_de_pago_abonos_bases.length; i++) {
                if (metodos_de_pago_abonos_bases[i]) {
                    const valor = typeof value === 'number' ? value : value.id;
                    if (metodos_de_pago_abonos_bases[i].id == valor) {
                        return metodos_de_pago_abonos_bases[i].nombre;
                    }
                } else {
                    return 'Método de pago no encontrado.';
                }
            }
        }
    };

    const formatearTimeLapse = value => {
        switch(value){
            case 0: return '12 horas';
            case 1: return '24 horas';
            case 2: return '48 horas';
            case 3: return '72 horas';
            case 4: return '1 semana';
            case 5: return '2 semanas';
            default: return '';
        }
    };

    const formatearMetodoPagoEntrada = value => {
        const metodos_pago_eventos = store.getters.getTeatro?.metodos_pago_eventos_ventas;

        if (metodos_pago_eventos && metodos_pago_eventos.length > 0) {
            for (let i = 0; i <= metodos_pago_eventos.length; i++) {
                if (metodos_pago_eventos[i]) {
                    if (metodos_pago_eventos[i].id == value) {
                        return metodos_pago_eventos[i].nombre;
                    }
                } else {
                    return 'Método de pago no encontrado.';
                }
            }
        }
    };

    const formatearModalidad = value => {
        switch(value){
            case 0: return 'ANTICIPADA';
            case 1: return 'TAQUILLA';
            default: return '';
        }
    };

    const formatearEstadoEvento = value => {
        switch(value){
            case 0: return 'BORRADOR';
            case 1: return 'PUBLICADO';
            case 2: return 'CANCELADO';
            default: return '';
        }
    };

    const formatearUrl = (value, params) => {
        let url = value;
        for(const i in params){
            url = url.replace(i, params[i]);
        }

        const qr_codes = params.qr_codes.join(',');
        const tid = params.tid;

        return url + '?qr_codes=' + qr_codes + '&api_key=' + localStorage.getItem('token') + '&tid=' + tid;
    };

    const calcularPrecioEntrada = (precio, entrada) => {
        precio = parseFloat(precio);

        if (!entrada.price_management_interno) {
            precio = precio + parseFloat(entrada.price_management);
        }

        return precio + '€';
    };

    const formatearMoneda = codigo => {
        switch(codigo){
            case 978: return '€';
            case 826: return '£';
            default: return '';
        } 
    };

    const formatearLiquidacionEstado = value => {
        switch(value){
            case 0: return 'Pendiente';
            case 1: return 'En revisión';
            case 2: return 'Liquidado';
            default: return '';
        }
    };

    return {
        formatearFecha,
        formatearPrecio,
        formatearMetodoPago,
        formatearTimeLapse,
        formatearMetodoPagoEntrada,
        formatearModalidad,
        formatearEstadoEvento,
        formatearUrl,
        calcularPrecioEntrada,
        formatearMoneda,
        formatearLiquidacionEstado
    };
}